export const tagColors: string[][] = [
  ['#79891C', '#A2B625', '#CAE42E', '#DFEF82'],
  ['#995C01', '#DF8804', '#FF9A00', '#FFC267'],
  ['#933E19', '#C45222', '#F5672A', '#F78555'],
  ['#903E92', '#B851BA', '#E064E2', '#ECA2EE'],
  ['#6B3FB3', '#8654D9', '#A171EF', '#C7A5FF'],
  ['#0369AB', '#017CCC', '#009BFF', '#67C3FF'],
  ['#228858', '#2DB675', '#37E391', '#88EEBE'],
];
